var map = {
	"./ActiveProjects.svg": 39314,
	"./Add-Compound.svg": 88867,
	"./Copy.svg": 12497,
	"./CreateProduct.svg": 83729,
	"./DeleteIcon.svg": 29408,
	"./DesignArtwork.svg": 97398,
	"./DownArrow.svg": 16735,
	"./EditIcon.svg": 91337,
	"./Filter.svg": 88944,
	"./Hamburger.svg": 97509,
	"./Help.svg": 48259,
	"./Home.svg": 64679,
	"./Management.svg": 16831,
	"./MyNotes.svg": 87677,
	"./MyTasks.svg": 45212,
	"./PrepareForLaunch.svg": 98889,
	"./ProductDetail.svg": 25426,
	"./ReportingAndAnalytics.svg": 86303,
	"./Settings.svg": 36021,
	"./StoreOrderability.svg": 46401,
	"./TastingPanel.svg": 27232,
	"./VendorManagement.svg": 51893,
	"./cut.svg": 44060,
	"./redo.svg": 81374,
	"./regenerate.svg": 8088,
	"./save.svg": 13685,
	"./undo.svg": 81160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80705;